<template>
  <div class="main">
    <div class="form-row">
      <div class="form-field">
        <b>Подтвердите номер телефона</b>
        На {{ hiddenPhone }} <br />
        отправлен проверочный код
      </div>
      <div class="form-field">
        <label for="reg-key-input">Введите код:</label>
        <input id="reg-key-input" v-model="phoneKey" type="text" />
        <button @click="confirmKey">Подтвердить</button>
      </div>
    </div>
    <div class="form-row" v-if="info">{{ info }}</div>
  </div>
</template>

<script>
import axios from "axios";
import config from "@/config";
import { mapState } from "vuex";

export default {
  name: "Register",
  data() {
    return {
      url: config.backend_url,
      phoneKey: null,
      info: false,
      waite: false
    };
  },
  computed: mapState({
    userId: state => state.user.profile.id,
    hiddenPhone: state => state.auth.userPhoneHidden,
    confirmRules: state => state.auth.confirmRules,
    userPhoneActivateToken: state => state.auth.userPhoneActivateToken
  }),
  methods: {
    confirmKey: function() {
      let self = this;
      let activateData = {};
      activateData.key = this.phoneKey;
      activateData.userId = this.userId;
      activateData.token = this.userPhoneActivateToken;
      axios
        .post(self.url + "users/activate/", {
          data: activateData
        })
        .then(function(response) {
          let data = response.data;
          if (data.error) {
            self.info = data.error;
          } else {
            self.$store.commit("auth/confirmPhone");
            if (self.confirmRules !== "Y") self.$router.push("/confirm-rules");
            else self.$router.push("/");
          }
        });
    }
  },
  mounted() {}
};
</script>
